import { payufinSessionStorage } from '@paysense-india-services/payufin-jsutils'

import { VALIDATE_SESSION_API } from '@/constants/api'
import { SESSION_STORAGE_KEYS } from '@/constants/sessionStorageKeys'

import apiService from '@/lib/apiUtils'

// Check session validity by making a call to session API
export async function checkSession(token) {
  try {
    const response = await apiService.post(VALIDATE_SESSION_API, { body: { auth_token: token } })
    const muid = response?.muid
    payufinSessionStorage?.setToSession(SESSION_STORAGE_KEYS.MASTER_USER_ID, muid)
    return { isActive: !!response.status }
  } catch {
    return { isActive: false }
  }
}
